import { adminAPI } from "../../api/adminAPI";
import { logout, setInformationUser } from "./authSlice";

export const getInformation = () => {
  return async (dispatch, actualState) => {
    const response = await adminAPI
      .get("/auth/get-information-jwt", {
        headers: {
          "x-token": actualState().auth.jwt,
        },
      })
      .catch(({ response }) => response);
    if (response.status !== 200) {
      dispatch(logout());
      return;
    }
    const { data } = response.data;
    dispatch(setInformationUser({ data }));
  };
};
